import { theme } from '@cast/design-system';
import {
  ComputeResourceType,
  ComputeResourceTypeExtended,
  PriceType,
} from '@cast/shared-types';

import { ResourceType } from 'types/compute';
import { NodeType } from 'types/nodes';

export const computeResourceNameMap: Record<ResourceType, string> = {
  [ComputeResourceType.CPU]: 'CPU',
  [ComputeResourceType.MEMORY]: 'Memory',
  [ComputeResourceTypeExtended.GPU]: 'GPU',
  [ComputeResourceTypeExtended.TPU]: 'TPU',
};

export const computeResourceWordMap: Record<ResourceType, string> = {
  [ComputeResourceType.CPU]: 'CPU',
  [ComputeResourceType.MEMORY]: 'memory',
  [ComputeResourceTypeExtended.GPU]: 'GPU',
  [ComputeResourceTypeExtended.TPU]: 'TPU',
};

export const computeResourceKeyMap: Record<
  ResourceType,
  'Cpu' | 'Ram' | 'Gpu' | 'Tpu'
> = {
  [ComputeResourceTypeExtended.CPU]: 'Cpu',
  [ComputeResourceTypeExtended.MEMORY]: 'Ram',
  [ComputeResourceTypeExtended.GPU]: 'Gpu',
  [ComputeResourceTypeExtended.TPU]: 'Tpu',
} as const;

export const computeResourceUnitsMap: Record<ResourceType, string> = {
  [ComputeResourceTypeExtended.CPU]: 'CPU',
  [ComputeResourceTypeExtended.MEMORY]: 'GiB',
  [ComputeResourceTypeExtended.GPU]: 'GPU',
  [ComputeResourceTypeExtended.TPU]: 'TPU',
};

export const fullPriceTypeMap: Record<PriceType, string> = {
  [PriceType.HOURLY]: 'hourly',
  [PriceType.DAILY]: 'daily',
  [PriceType.MONTHLY]: 'monthly',
};

export const priceTypeMap: Record<PriceType, string> = {
  [PriceType.HOURLY]: 'h',
  [PriceType.DAILY]: 'd',
  [PriceType.MONTHLY]: 'mo',
};

export const promos: Record<string, string> = {
  eks: '/external-clusters/new#eks',
  gke: '/external-clusters/new#gke',
  kops: '/external-clusters/new#kops',
};

export const nodeTypeColors = {
  [NodeType.ON_DEMAND]: theme.palette.blue[300],
  [NodeType.SPOT]: theme.palette.indigo[800],
  [NodeType.FALLBACK]: theme.palette.yellow[400],
};
